<template>
  <div class="container-xxl">
    <div class="row">
      <div class="col-12">
        <div class="date-filter-wrap mt-3">
          <h3 class="date-filter-title mb-3">Ημερομηνία</h3>

          <div class="top-statistics-bar justify-content-between">
            <div class="date-input-wrap d-flex align-items-center gap-1">
              <label for="startDate">Απο:</label>
              <input type="text" class="date-input" id="startDate" v-model="startDate" placeholder="ηη/μμ/εεεε"/>

              
              <label for="endDate">Εως:</label>
              
              <input type="text" class="date-input" id="endDate" v-model="endDate" placeholder="ηη/μμ/εεεε"/>
              <img class="date-filter-btn" src="../assets/images/filter-icon.png" @click="filterByDate" />
            </div>

            <div class="justify-content-end export-wrap">
              <button class="btn btn-primary" @click="exportCSV">
                Εξαγωγή
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 mb-3 mt-3" v-if="statistics.eventStats.length">
        <div class="card h-100 shadow-sm">
          <div class="card-body">
            <h5 class="card-title mb-3">Συνολική Εικόνα</h5>
            <div class="row text-center">
              <div class="col-6 col-md mb-3">
                <div class="fw-bold stat-title">Συνολικά Έσοδα</div>
                <div class="stat-price">{{ totalRevenue }}€</div>
              </div>
              <div class="col-6 col-md mb-3">
                <div class="fw-bold stat-title">Σύνολο Εισιτηρίων</div>
                <div class="stat-number">{{ totalTickets }}</div>
              </div>
              <div class="col-6 col-md mb-3">
                <div class="fw-bold stat-title text-success">Πωλήθηκαν</div>
                <div class="stat-number text-success">{{ totalSold }}</div>
              </div>
              <div class="col-6 col-md mb-3">
                <div class="fw-bold stat-title text-success">Χρησιμοποιήθηκαν</div>
                <div class="stat-number text-success">{{ totalUsed }}</div>
              </div>
              <div class="col-6 col-md mb-3">
                <div class="fw-bold stat-title text-primary">Απομένουν</div>
                <div class="stat-number text-primary">{{ totalRemaining }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-6 col-lg-4 mb-3" v-for="event in statistics.eventStats" :key="event.event_id + '-' + event.event_date_id">
        <div class="card h-100 shadow-sm">
          <div class="card-body">
              <h5 class="card-title">{{ event.event_title }}</h5>
              <h6 class="card-subtitle mb-2 text-muted">
              {{ event.date }} | {{ event.start_time }} - {{ event.end_time }}
              </h6>
              <ul class="list-group list-group-flush my-3">
                <li class="list-group-item d-flex justify-content-between">
                    <span class="stat-title">Σύνολο Εισιτηρίων</span>
                    <span class="stat-number">{{ event.total_tickets }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between text-success">
                    <span class="stat-title">Πωλήθηκαν</span>
                    <span class="stat-number">{{ event.tickets_sold }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between text-primary">
                    <span class="stat-title">Απομένουν</span>
                    <span class="stat-number">{{ event.tickets_remaining }}</span>
                </li>
                    <li class="list-group-item d-flex justify-content-between text-primary">
                    <span class="stat-title">Χρησιμοποιήθηκαν</span>
                    <span class="stat-number">{{ event.tickets_used }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between fw-bold">
                    <span class="stat-title">Έσοδα</span>
                    <span class="stat-price">{{ event.revenue }}€</span>
                </li>
              </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script setup>
  import { ref, onMounted, computed } from 'vue';
  import { fetchStatistics } from '@/services/statistics';
  import { useToast } from 'vue-toastification';
  import { useHead } from '@vueuse/head';
  import apiClient from '@/services/api';

  const statistics = ref({ eventStats: [] });
  const toast = useToast();
  const startDate = ref(null);
  const endDate = ref(null);
  import { useRouter } from 'vue-router';

 
  const router = useRouter();

   const fetchStats = async () => {
    try {
      const response = await fetchStatistics();
      statistics.value = response.data.data;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        router.push('/');
      } else {
        toast.error('An error occurred while fetching statistics.');
      }
    }
  };


  const totalRevenue = computed(() => {
    return statistics.value.eventStats.reduce((sum, ev) => {
      return sum + (Number(ev.revenue) || 0);
    }, 0);
  });

  const totalTickets = computed(() => {
    return statistics.value.eventStats.reduce((sum, ev) => {
      return sum + (Number(ev.total_tickets) || 0);
    }, 0);
  });

  const totalSold = computed(() => {
    return statistics.value.eventStats.reduce((sum, ev) => {
      return sum + (Number(ev.tickets_sold) || 0);
    }, 0);
  });

    const totalUsed = computed(() => {
    return statistics.value.eventStats.reduce((sum, ev) => {
      return sum + (Number(ev.tickets_used) || 0);
    }, 0);
  });


  const totalRemaining = computed(() => {
    return statistics.value.eventStats.reduce((sum, ev) => {
      return sum + (Number(ev.tickets_remaining) || 0);
    }, 0);
  });



  const filterByDate = async () => {
    try {
      const response = await fetchStatistics({
        start_date: startDate.value,
        end_date: endDate.value
      });

      if (response.data?.success) {
        statistics.value = response.data.data;
      } else {
        toast.error('No data found for this period.');
      }
    } catch (error) {
      toast.error('An error occurred while filtering statistics.');
    }
  };


  const exportCSV = async () => {
    try {
      const params = {
        start_date: startDate.value,
        end_date: endDate.value,
        export: true
      };

      // axios request with responseType blob
      const response = await apiClient.get('/get-statistics', {
        params,
        responseType: 'blob' // <-- important for files
      });

      // create temporary download link
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `event_statistics_${new Date().toISOString().slice(0,19)}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (error) {
      toast.error('An error occurred while exporting statistics.');
    }
  };




  



  onMounted(() => {
    flatpickr("#startDate", { disableMobile: true });
    flatpickr("#endDate", { disableMobile: true });

    useHead({
      title: 'Στατιστικά - Πλατφόρμα Διαχείρισης Ηλεκτρονικού Εισιτηρίου',
    });

    fetchStats();
  });
</script>





<style scoped>
  .card {
    transition: transform 0.2s;
  }
  .card:hover {
    transform: translateY(-5px);
  }

  .card-subtitle{
    font-size: 18px;
  }

  .stat-title{
    font-weight: 500;
    font-size: 18px;
  }

  .stat-number{
    font-weight: 700;
    font-size: 18px;
  }

  .stat-price{
    font-weight: 700;
    font-size: 18px;
  }

  #endDate,
  #startDate{
    padding-left:5px;
  }

  .date-input-wrap{
    display: flex;
  }

 

  .top-statistics-bar{
    display: flex;
  }

  @media (max-width: 576px) {
    .stat-price,
    .stat-number,
    .stat-title{
      font-size: 16px;
    }

    #endDate,
    #startDate{
      width:110px;
    }

    .top-statistics-bar{
      display: block;
    }

    .export-wrap{
      margin-top:12px;
    }
    
  }

</style>
